import React, { useEffect } from 'react';
import Modal from '@/components/ui/Modal';
import { DeviceSession, User } from '@/types/model';
import { userService } from '@/services';
import Button from '@/components/ui/Button.tsx';
interface CreditsModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: User;
}

const DeviceSessionModal: React.FC<CreditsModalProps> = ({ isOpen, onClose, user }) => {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [device, setDevice] = React.useState<DeviceSession>({} as DeviceSession);

  useEffect(() => {
    const fetchUserDevices = async () => {
      try {
        setLoading(true);
        const device = await userService.getUserDevices(user.id);
        setDevice(device)
      } catch (error) {
        console.log("Error fetching user devices:", error);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      fetchUserDevices();
    }
  }, [isOpen, user.id]);

  const terminateSession = async () => {
    try {
      setLoading(true);
      await userService.terminateUserDeviceSession(user.id);
      onClose();
      alert("Dispositivo desvinculado exitosamente.");
    } catch (error) {
      console.log("Error terminating device session:", error);
    } finally {
      setLoading(false);
    }
  }


  return (
    <Modal isOpen={isOpen} onClose={onClose} title={"Dispositivo del usuario: " + user.username} size="lg">
      <div className="space-y-6">
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="flex items-center space-x-3">
            <dl className="divide-y divide-gray-100 ">
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">Marca</dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{device.deviceInfo?.manufacturer}</dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900 ">Modelo</dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 ">{device.deviceInfo?.model}</dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900 ">OS Version</dt>
                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{device.osVersion}</dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">SDK Version</dt>
                <dd
                  className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{device.sdkInt}
                </dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">App Version</dt>
                <dd
                  className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{device.appVersionName}
                </dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm/6 font-medium text-gray-900">ID Dispositivo</dt>
                <dd
                  className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{device.macAddress}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

      <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
        <Button
          type="submit"
          variant="danger"
          onClick={terminateSession}
          loading={loading}
          disabled={loading}
        >
          Desvincular
        </Button>
        <Button
          type="button"
          variant="outline"
          onClick={onClose}
          disabled={loading}
        >
          Cerrar
        </Button>
      </div>
    </Modal>
);
};

export default DeviceSessionModal;
